































































import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import { TextOptions } from "../../../interfaces/drawOptions";
@Component
export default class TextDialog extends Vue {
    @Prop() dialogActive!: boolean;
    public textOptions: TextOptions = { color: "#000000FF", size: 1, text: "" };
    // for the slider in the color pickers

    public get showDialog(): boolean {
        return this.dialogActive;
    }
    public set showDialog(e: boolean) {
        this.done();
    }

    public get swatches() {
        return [
            ["#FF0000FF"],
            ["#FFF500FF"],
            ["#00FF2CFF"],
            ["#006FFFFF"],
            ["#FF00FDFF"],
            ["#000000FF"],
        ];
    }

    public colorUpdate(color: { hexa: string }) {
        this.textOptions.color = color.hexa;
    }

    public doneHandler() {
        this.done();
        this.textOptions.text = "";
    }

    @Emit() done() {
        return this.textOptions;
    }
}
